var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { PieChart, Pie, Cell, Tooltip as RechartsTooltip } from 'recharts';
import classNames from 'classnames';
import Label from './GaugeChartLabel';
import Tooltip from './GaugeChartTooltip';
import LabelLine from './GaugeChartLabelLine';
import { SIZE_L, SIZE_M, SIZE_S, DEFAULT_STROKE_COLOR } from '../constants';
import Icon from '../../icon/components/Icon';
export var prepareData = function (data) { return data.map(function (a) { return (__assign(__assign({}, a), { value: a.max - a.min })); }); };
var s = {
    height: 105,
    width: 155,
    innerRadius: 50,
    outerRadius: 68,
    fontSize: 22,
    labelFontSize: 10,
    cx: 72,
    cy: 90,
};
var m = {
    height: 105,
    width: 180,
    innerRadius: 70,
    outerRadius: 90,
    fontSize: 30,
    labelFontSize: 15,
    cx: 85,
    cy: 100,
};
var l = {
    height: 125,
    width: 255,
    innerRadius: 85,
    outerRadius: 110,
    fontSize: 37,
    labelFontSize: 15,
    cx: 120,
    cy: 120,
};
var GaugeChart = /** @class */ (function (_super) {
    __extends(GaugeChart, _super);
    function GaugeChart(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { tooltip: null, animated: _this.props.animated };
        _this.setTooltip = _this.setTooltip.bind(_this);
        return _this;
    }
    GaugeChart.prototype.componentWillReceiveProps = function (props) {
        this.setState({ animated: props.animated });
    };
    GaugeChart.prototype.setTooltip = function (tooltip) {
        this.setState({ tooltip: tooltip, animated: false });
    };
    GaugeChart.prototype.render = function () {
        var _this = this;
        var selectedSize;
        var _a = this.state, tooltip = _a.tooltip, animated = _a.animated;
        var _b = this.props, showStrokes = _b.showStrokes, ticks = _b.ticks, value = _b.value, color = _b.color, label = _b.label, size = _b.size, forcedStatus = _b.forcedStatus;
        switch (size) {
            case SIZE_L:
                selectedSize = l;
                break;
            case SIZE_M:
                selectedSize = m;
                break;
            case SIZE_S:
                selectedSize = s;
                break;
            default:
                selectedSize = m;
        }
        return (React.createElement("div", null,
            forcedStatus &&
                React.createElement(Icon, { iconName: "patch", className: classNames('gaugeChart__patchIcon', forcedStatus.toLowerCase()) }),
            React.createElement("g", { className: "gaugeChart" },
                React.createElement(PieChart, { height: selectedSize.height, width: selectedSize.width },
                    React.createElement(Pie, { dataKey: "value", data: prepareData(ticks), cx: selectedSize.cx, cy: selectedSize.cy, startAngle: 180, endAngle: 0, innerRadius: selectedSize.innerRadius, outerRadius: selectedSize.outerRadius, label: function () { return React.createElement(Label, __assign({}, label, { chartWidth: selectedSize.width, cy: selectedSize.cy, fontSize: selectedSize.fontSize, labelFontSize: selectedSize.labelFontSize })); }, labelLine: function (props) { return (React.createElement(LabelLine, { outerRadius: props.outerRadius, show: props.show, startAngle: props.startAngle, tickColor: props.tickColor, tooltip: props.tooltip, cx: props.cx, cy: props.cy, setTooltip: _this.setTooltip })); }, isAnimationActive: false }, ticks.map(function (item) { return React.createElement(Cell, { key: item.backColor, fill: item.backColor, stroke: showStrokes ? DEFAULT_STROKE_COLOR : item.backColor }); })),
                    React.createElement(Pie, { dataKey: "value", data: [{ value: value }], cx: selectedSize.cx, cy: selectedSize.cy, startAngle: 180, endAngle: 180 - (1.8 * value), paddingAngle: 0, innerRadius: selectedSize.innerRadius, outerRadius: selectedSize.outerRadius, isAnimationActive: animated, labelLine: false },
                        React.createElement(Cell, { fill: color, stroke: color })),
                    React.createElement(RechartsTooltip, { content: function () { return (tooltip ?
                            React.createElement(Tooltip, { amount: tooltip.amount, records: tooltip.records, percent: tooltip.percent, color: tooltip.color }) : null); }, position: tooltip ? tooltip.position : { x: 0, y: 0 } })))));
    };
    return GaugeChart;
}(React.Component));
export default GaugeChart;
//# sourceMappingURL=GaugeChart.js.map